import React from "react";
import Card from "../ui/card/Card";
import ActionButton from "../actions/ActionButton";
import UpdateOrder from "./UpdateOrder";
import Stack from "../ui/Stack";
import OrderItem from "./OrderItem";
import { msToHours, date } from "../Utility";
import { Role } from "../../enums/enums";
import { useSelector } from "react-redux";
import TrackOrderSteps from "./TrackOrderSteps";

const OrderList = ({ items, timezone, formData, onOrderUpdate, editOrder = true }) => {
    const userRole = useSelector((state) => state.auth.selectedRole);
    if (!items.length) return <h6>No orders found</h6>;

    return items.map((item) => (
        <Card key={item.id}
            className={`border-0 mb-4 p-4${(item.orderStatus === 3 && item.paymentStatus === 1) ? " bg-success bg-opacity-25" : ""} ${item.orderStatus === -1 ? " bg-danger bg-opacity-25" : ""}`}>
            <OrderItem item={item} timezone={timezone} />
            <Stack className="gap-3">
                {editOrder && msToHours(date() - date(item.orderTime)) < 2 && (
                    <ActionButton
                        permissions={['BranchAdmin', 'BranchOwner', 'BranchManager']}
                        to={`${item._id}/edit`}
                        className="btn bg-primary bg-opacity-25 fs-sm fw-medium rounded-2 py-1"
                    >
                        Edit Order
                    </ActionButton>
                )}
                {formData && <UpdateOrder formData={formData} item={item} onOrderUpdate={onOrderUpdate} />}
            </Stack>
            {userRole.role === Role.Employee &&
                <TrackOrderSteps item={item} />
            }
        </Card>
    ));
};

export default OrderList;